// Date renderer — plan §6.3. Native <input type="date"> (YYYY-MM-DD); soru biçimi
// "MM-YYYY" ise <input type="month"> (değer "YYYY-MM" — Finar İ8). Eski/aktarılmış tam
// tarih ay/yıl sorusunda ay kısmıyla gösterilir (`dateInputValue`). `type=month`
// desteklemeyen tarayıcıda metin kutusu: yarım değer yerelde kalır, yalnız tam ay/yıl gönderilir.
import { useEffect, useState } from "react";
import { dateInputValue, readDateFormat } from "@mahir/shared";
import { DATE_INPUT_COPY, monthYearToSend, supportsMonthInput } from "../../../lib/date-input-ui";

interface Props {
  value: string | null;
  onChange: (v: string | null) => void;
  /** Soru (ya da composite parçası) seçenekleri — `format` buradan okunur. */
  options?: unknown;
}

const inputStyle = {
  background: "var(--color-surface)",
  border: "1px solid var(--color-border)",
  color: "var(--color-text)",
  fontFamily: "var(--font-mono)",
};

export function DateRenderer({ value, onChange, options }: Props): JSX.Element {
  const format = readDateFormat(options);
  if (format === "MM-YYYY" && !supportsMonthInput()) {
    return <MonthTextInput value={dateInputValue(value, format)} onChange={onChange} />;
  }
  return (
    <input
      type={format === "MM-YYYY" ? "month" : "date"}
      value={dateInputValue(value, format)}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v.length > 0 ? v : null);
      }}
      className="rounded-lg px-3 py-2 text-sm"
      style={inputStyle}
    />
  );
}

function MonthTextInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string | null) => void;
}): JSX.Element {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  const invalid = monthYearToSend(draft) === undefined;
  return (
    <span className="inline-flex flex-col gap-1">
      <input
        type="text"
        inputMode="numeric"
        placeholder={DATE_INPUT_COPY.monthPlaceholder}
        pattern={DATE_INPUT_COPY.monthPattern}
        maxLength={7}
        value={draft}
        aria-invalid={invalid || undefined}
        title={DATE_INPUT_COPY.monthInvalidHint}
        onChange={(e) => {
          setDraft(e.target.value);
          const send = monthYearToSend(e.target.value);
          if (send !== undefined) onChange(send);
        }}
        className="rounded-lg px-3 py-2 text-sm"
        style={inputStyle}
      />
      {invalid ? (
        <span style={{ fontSize: "0.75rem", color: "var(--color-text-3)" }}>
          {DATE_INPUT_COPY.monthInvalidHint}
        </span>
      ) : null}
    </span>
  );
}
